export default __webpack_public_path__ + "static/media/_ic_home_act.3b90aba6.svg";